// extracted by mini-css-extract-plugin
export var pillWrapper = "_hn-0";
export var showOverflow = "_hn-1";